export default {
	root: {
		fontFamily: 'Work Sans',
	},
};
